import { render, staticRenderFns } from "./IncomesList.vue?vue&type=template&id=2d0fd915&"
import script from "./IncomesList.vue?vue&type=script&lang=js&"
export * from "./IncomesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports